export * from './print-form.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/print/print-form/index.ts